import React, { useState } from "react";
import { Box, Modal } from "@mui/material";
import TypeNoteChip from "../Chips/TypeNoteChip";
import DeleteNote from "./DeleteNote";
import EditEndOfShiftNote from "./EditEndOfShiftNote";
import ViewEndOfShiftNote from "./ViewEndOfShiftNote";
import EditButtonMobile from "../Buttons/EditButtonMobile";
import ViewButtonSmall from "../Buttons/ViewButtonSmall";
import DeleteButtoMobile from "../Buttons/DeleteButtoMobile";
import DateAndTimeChipMobile from "../Chips/DateAndTimeChipMobile";

function EndOfShiftNoteContainerMobile(props) {
  const [showViewModal, setShowViewModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const openViewModal = () => {
    setShowViewModal(true);
  };
  const closeViewModal = () => {
    setShowViewModal(false);
  };

  const openEditModal = () => {
    setShowEditModal(true);
  };
  const closeEditModal = () => {
    setShowEditModal(false);
  };

  const openDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };


  const styleEdit2 = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    height: "80%",
    borderRadius: 5,
    backgroundColor: "white",
    /*border: "1px solid #000",*/
    boxShadow: 24,
  };

  const styleDeleteModal = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 300,
    height: 260,
    borderRadius: 2,
    bgcolor: "background.paper",
    boxShadow: 24,
  };

  return (
    <div className="notes-wrapper">
      <Modal open={showEditModal} onClose={closeEditModal}>
        <Box sx={styleEdit2}>
          <EditEndOfShiftNote
            noteId={props.noteId}
            noteContent={props.noteContent}
            shiftStart={props.shiftStartRaw}
            shiftEnd={props.shiftEndRaw}
            staff={props.staff}
            closemodal={closeEditModal}
            {...props}
          />
        </Box>
      </Modal>

      <Modal open={showDeleteModal} onClose={closeDeleteModal}>
        <Box sx={styleDeleteModal}>
          <DeleteNote
            note={props.noteContent}
            noteId={props.noteId}
            typeOfNote={props.noteType}
            effectiveDate={props.effectiveDate}
            closemodal={closeDeleteModal}
          />
        </Box>
      </Modal>

      <Modal open={showViewModal} onClose={closeViewModal}>
        <Box sx={styleEdit2}>
          <ViewEndOfShiftNote
            noteId={props.noteId}
            noteContent={props.noteContent}
            shiftStart={props.shiftStart}
            shiftEnd={props.shiftEnd}
            staff={props.staff}
            closemodal={closeViewModal}
            {...props}
          />
        </Box>
      </Modal>

      <div className="note-container-mobile">
        <div className="note-container-block-1-mobile">
          <DateAndTimeChipMobile date={props.noteDate} />
          <DateAndTimeChipMobile date={props.noteTime} />
          <TypeNoteChip noteType={props.noteType} />
        </div>

        <div className="note-container-block-3-mobile">
          <div className="note-container-line-1-mobile">
            <div
              className="note-container-line1-block1bis-mobile left-block"
              // onClick={handleNavigate}
              style={{ cursor: "pointer", width: "60%" }}
            >
              <div className="title-cell-container">Done by (staff):</div>
              <div className="content-cell-container">{props.staff}</div>
            </div>

            <div
              className="note-container-line1-block2-mobile centre-block2"
              style={{ width: "40%" }}
            >
              <div className="sub-block-2">
                <EditButtonMobile handleOpen={openEditModal} />
                <ViewButtonSmall handleOpen={openViewModal} />
                <DeleteButtoMobile handleOpen={openDeleteModal} />
              </div>
            </div>
          </div>
          <div
            className="note-container-line-2-mobile"
            style={{ whiteSpace: "pre-wrap" }}
          >
            {props.noteContent}
          </div>
        </div>
      </div>
    </div>
  );
}

export default EndOfShiftNoteContainerMobile;
